require("source-map-support").install(), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Row", [], t) : "object" == typeof exports ? exports.Row = t() : e.Row = t();
}(this, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/", r(r.s = 413);
  }({
    0: function _(e, t) {
      e.exports = require("react");
    },
    11: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
    },
    142: function _(e, t, r) {
      "use strict";

      r.r(t);
      var n = r(38),
          o = r(21);
      r.d(t, "RowV2", function () {
        return o.a;
      }), t.default = n.a;
    },
    2: function _(e, t) {
      e.exports = require("styled-components");
    },
    21: function _(e, t, r) {
      "use strict";

      var n = r(3),
          o = r.n(n),
          u = r(6),
          i = r.n(u),
          c = r(11),
          a = r.n(c),
          f = r(0),
          l = r.n(f),
          p = r(2),
          s = r.n(p),
          b = r(7);

      function d() {
        var e = o()(["\n  display: flex;\n  position: relative;\n  max-width: ", ";\n\n  flex: ", ";\n  flex-wrap: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n\n  ", "\n  ", "\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      function v(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      var y = function y(e) {
        var t = e.children,
            r = e.gutter,
            n = a()(e, ["children", "gutter"]);
        return l.a.createElement(g, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? v(Object(r), !0).forEach(function (t) {
              i()(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : v(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }({
          gutter: r
        }, n), l.a.Children.map(t, function (e) {
          return e && l.a.cloneElement(e, {
            gutter: r
          });
        }));
      },
          g = s.a.div(d(), function (e) {
        return e.width || "none";
      }, function (e) {
        return e.flex;
      }, function (e) {
        return e.flexWrap ? "wrap" : "nowrap";
      }, function (e) {
        return e.reverse ? "row-reverse" : "row";
      }, function (e) {
        return e.alignItems;
      }, function (e) {
        return e.justifyContent;
      }, function (e) {
        var t = e.gutter;
        return Object(b.a)({
          attribute: "margin-left",
          value: t ? -t / 2 : 0
        });
      }, function (e) {
        var t = e.gutter;
        return Object(b.a)({
          attribute: "margin-right",
          value: t ? -t / 2 : 0
        });
      });

      g.displayName = "RowV2", y.defaultProps = {
        flex: "1 1 auto",
        gutter: 0,
        reverse: !1,
        flexWrap: !1,
        alignItems: void 0,
        justifyContent: void 0
      }, t.a = y;
    },
    3: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    38: function _(e, t, r) {
      "use strict";

      var n = r(3),
          o = r.n(n),
          u = r(6),
          i = r.n(u),
          c = r(11),
          a = r.n(c),
          f = r(0),
          l = r.n(f),
          p = r(2),
          s = r.n(p),
          b = r(7);

      function d() {
        var e = o()(["\n  display: flex;\n  position: relative;\n  width: auto;\n\n  ", "\n  ", "\n\n  flex: ", ";\n  flex-wrap: ", ";\n  flex-direction: ", ";\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      function v(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      var y = function y(e) {
        var t = e.children,
            r = e.gutter,
            n = e.className,
            o = a()(e, ["children", "gutter", "className"]);
        return l.a.createElement(g, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? v(Object(r), !0).forEach(function (t) {
              i()(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : v(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }({
          gutter: r
        }, o, {
          className: n
        }), l.a.Children.map(t, function (e) {
          return l.a.cloneElement(e, {
            gutter: r
          });
        }));
      },
          g = s.a.div(d(), function (e) {
        var t = e.gutter;
        return Object(b.a)({
          attribute: "margin-left",
          value: t ? -t / 2 : 0
        });
      }, function (e) {
        var t = e.gutter;
        return Object(b.a)({
          attribute: "margin-right",
          value: t ? -t / 2 : 0
        });
      }, function (e) {
        return e.flex;
      }, function (e) {
        return e.flexWrap ? "wrap" : "no-wrap";
      }, function (e) {
        return e.reverse ? "row-reverse" : "row";
      });

      y.defaultProps = {
        flex: "1 1 auto",
        gutter: 0,
        reverse: !1,
        flexWrap: !1,
        className: ""
      }, t.a = y;
    },
    413: function _(e, t, r) {
      e.exports = r(142);
    },
    6: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/defineProperty");
    },
    7: function _(e, t, r) {
      "use strict";

      var n = r(3),
          o = r.n(n),
          u = r(2);

      function i() {
        var e = o()(["", ": ", ""]);
        return i = function i() {
          return e;
        }, e;
      }

      function c() {
        var e = o()(["", ": ", "px"]);
        return c = function c() {
          return e;
        }, e;
      }

      t.a = function (e) {
        var t = e.attribute,
            r = e.value;

        if (void 0 !== r) {
          if ("number" == typeof r) return Object(u.css)(c(), t, r);
          if ("string" == typeof r) return Object(u.css)(i(), t, r);
          throw new Error("".concat(r, " is not of valid type for ").concat(t, ".\n      prop can either number or string"));
        }
      };
    }
  });
});